import {Component} from '@angular/core';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
    selector: 'app-error503',
    imports: [
    FaIconComponent
],
    templateUrl: './error503.component.html',
    styleUrls: ['./error503.component.css']
})
export class Error503Component {
  faExclamationTriangle = faExclamationTriangle;
}
